import React from 'react';
import { Menu, Layout } from 'antd';
import { 
  DashboardOutlined, TeamOutlined, GlobalOutlined,
  ShoppingCartOutlined, UserOutlined
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';

const { Sider } = Layout;

const Navbar = ({ collapsed, onCollapse, activeTab }) => {
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  console.log(user);
  const getMenuItems = () => {
    const baseItems = [
      {
        key: 'dashboard',
        icon: <DashboardOutlined />,
        label: <Link to="/dashboard">Dashboard</Link>,
      },
      {
        key: 'plans',
        icon: <ShoppingCartOutlined />,
        label: <Link to="/dashboard?tab=plans">Plans</Link>,
      }
    ];

    if (user.type === 'Partner') {
      baseItems.push({
        key: 'connections',
        icon: <TeamOutlined />,
        label: <Link to="/connections">Connections</Link>,
      });
    }

    if (user.type === 'Business') {
      baseItems.push({
        key: 'employees',
        icon: <TeamOutlined />,
        label: <Link to="/employees">Employees</Link>,
      });
    }

    baseItems.push({
      key: 'profile',
      icon: <UserOutlined />,
      label: <Link to="/dashboard?tab=profile">Profile</Link>,
    });
        baseItems.push({
      key: 'Visit Website',
      icon: <GlobalOutlined />,
      label: <Link to="/" target='_blank'>Visit Website</Link>,
    });

    return baseItems;
  };

  return (
    <div></div>
    // <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
    //   <div className="logo" style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)' }}>
    //     {collapsed ? 'SB' : 'Startup Business'}
    //   </div>
    //   {/* <Menu 
    //     theme="dark" 
    //     mode="inline" 
    //     selectedKeys={[activeTab]}
    //     items={getMenuItems()}
    //   /> */}
    // </Sider>
  );
};

export default Navbar;